﻿import React from 'react';
import {Grid, GridOwnProps, Theme} from "@mui/material";
import {styled} from "@mui/styles";

export const SecurSpaceReportContainerRoot = styled(Grid)(({theme}: { theme: Theme }) => ({
  paddingTop: '2.5rem',
  paddingBottom: '2.86rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  // Tablet band: jumping straight from 1rem to 8.04rem at `sm` ate ~225px
  // (root font-size is 14px) of a ~620px viewport, so reports collapsed into a
  // narrow centred column right above the phone breakpoint. Step through it.
  [theme.breakpoints.up('sm')]: {
    paddingLeft: '2.5rem',
    paddingRight: '2.5rem',
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: '8.04rem',
    paddingRight: '8.04rem',
  }
}));

/**
 * Opinionated layout wrapper for report-style pages, built on MUI `Grid`.
 *
 * Applies standard page padding commonly used in Securspace Reports — `1rem` on mobile,
 * `2.5rem` on `sm` (tablet), `8.04rem` on `md`+ breakpoints — without requiring each
 * report view to redeclare those values.
 * Also provides `rowGap={1}` for consistent vertical spacing between grid items.
 *
 * Because the root element is a Grid container direct children can participate in the MUI grid system (e.g. `<Grid item xs={12}>`) without needing an additional wrapper.
 *
 * @example
 * // Simple report page
 * <SecurSpaceReportContainer>
 *   <Grid item xs={12}>
 *     <MyReportContent />
 *   </Grid>
 * </SecurSpaceReportContainer>
 *
 */
const SecurSpaceReportContainer = (props: GridOwnProps) => {
  return <SecurSpaceReportContainerRoot container rowGap={1} {...props} />
}

export { SecurSpaceReportContainer };
